/**
 * Service Worker Registration Utility
 * Handles registration, updates, and lifecycle management
 */

export function register(config) {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            registerValidSW(swUrl, config);
        });
    }
}

async function registerValidSW(swUrl, config) {
    try {
        const registration = await navigator.serviceWorker.register(swUrl);

        registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
                return;
            }

            installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // New content available, notify user
                        console.log('New content is available; please refresh.');

                        if (config && config.onUpdate) {
                            config.onUpdate(registration);
                        }
                    } else {
                        // Content cached for offline use
                        console.log('Content is cached for offline use.');

                        if (config && config.onSuccess) {
                            config.onSuccess(registration);
                        }
                    }
                }
            };
        };
    } catch (error) {
        console.error('Error during service worker registration:', error);
    }
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister();
            })
            .catch((error) => {
                console.error(error.message);
            });
    }
}

export function checkForUpdates() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.update();
            })
            .catch((error) => {
                console.error('Error checking for updates:', error);
            });
    }
}
